import {
    ISSUE_TYPE_MILESTONE, ISSUE_TYPE_MISCELLANEOUS, ISSUE_TYPE_PUBLIC_HOLIDAY, ISSUE_TYPE_REMINDER, ISSUE_TYPE_VACATION,
} from "../../constants";

let rootLabelKeys: Readonly<Record<string, string>> | null = null;

/**
 * The translation key that names a root type (D54), or null for any other uid. A fixed list of five
 * literal keys, so the translation editor (which manages only keys present in de.json) can find them.
 * The map is built on first use, not at import, because IssueType imports this module and many tests
 * replace the constants module with a partial stand-in.
 */
export function rootLabelKey(uid: string): string | null {
    rootLabelKeys ??= {
        [ISSUE_TYPE_MISCELLANEOUS]: 'issue-type.root.todo',
        [ISSUE_TYPE_MILESTONE]: 'issue-type.root.milestone',
        [ISSUE_TYPE_VACATION]: 'issue-type.root.absence',
        [ISSUE_TYPE_PUBLIC_HOLIDAY]: 'issue-type.root.holiday',
        [ISSUE_TYPE_REMINDER]: 'issue-type.root.reminder',
    };
    return rootLabelKeys[uid] ?? null;
}
